<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="datePickerMenuOn"
    lazy
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-model="value.date"
      :label="label"
      :suffix="value.accuracy"
      :rules="rules"
      readonly
    ></v-text-field>
    <v-list class="pa-0 ma-0">
      <v-date-picker
        :value="value.date"
        @change="value => updateValue({ date: value })"
        no-title
        scrollable
      ></v-date-picker>
      <v-radio-group
        :value="value.accuracy"
        @change="value => updateValue({ accuracy: value })"
        row
        class="pa-0 my-0 mx-12"
        style="justify-content: center;"
      >
        <v-radio label="Day" value="Day"></v-radio>
        <v-radio label="Month" value="Month"></v-radio>
        <v-radio label="Year" value="Year"></v-radio>
      </v-radio-group>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "AccuracyDatePicker",
  props: {
    label: String,
    value: {
      type: Object,
      required: true,
      default: () => ({ date: "", accuracy: "" }),
    },
    rules: Array,
  },
  data() {
    return {
      datePickerMenuOn: false,
    };
  },
  computed: {
    isvalid() {
      return this.value.date && this.value.date !== "";
    },
    dateFormatted() {
      return this.isvalid ? `${this.value.date} | ${this.value.accuracy}` : "";
    },
  },
  methods: {
    updateValue(value) {
      let updatedValue = { ...this.value, ...value };
      if (updatedValue.accuracy !== "") {
        updatedValue.accuracy = updatedValue.accuracy || "Day";
      }
      this.$emit("input", updatedValue);
    },
  },
};
</script>
